import { _t } from "@cruisen/i18n"
import * as yup from "yup"
import { isPhoneValid } from "../../../../utils/validation.ts"

export const nameRegex = /^[A-Za-z -]+$/

const getOnlyDigits = (value: string) => value.replace(/\D/g, "")

export const guestSchema = (loggenInUserPhoneNumber: string) =>
  yup.object().shape({
    firstName: yup
      .string()
      .required("-")
      .matches(nameRegex, _t("validation.useOnlyEnglishLetters")),
    lastName: yup.string().required("-").matches(nameRegex, _t("validation.useOnlyEnglishLetters")),
    ageGroup: yup.string().required("-"),
    dob: yup.string().optional(),
    phoneNumber: yup
      .string()
      .test("phone", "-", (value) => {
        if (!value) return true
        return isPhoneValid(value, true)
      })
      .test("phone", "You cannot use your own phone number", (value) => {
        if (!value) return true
        return getOnlyDigits(value) !== getOnlyDigits(loggenInUserPhoneNumber)
      }),
    profileId: yup.string().optional(),
  })
